module.exports = __webpack_public_path__ + "img/device-info.fefcb17a.svg";